import React, { useState } from 'react';
import { Car, Shield, Cpu, Zap, BarChart, MessageCircle, ChevronRight, Menu, X } from 'lucide-react';
import './AutoTechWebsite.css';

const AutoTechWebsite = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  
  return (
    <div className="website-container">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="logo-container">
              <div className="logo-icon">
                <Car size={32} />
              </div>
              <h1 className="logo-text">AutoTech Innovationen</h1>
            </div>
            
            <button onClick={toggleMenu} className="menu-toggle">
              {menuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
            
            <nav className="desktop-nav">
              <a href="#solutions" className="nav-link">Lösungen</a>
              <a href="#products" className="nav-link">Produkte</a>
              <a href="#technology" className="nav-link">Technologie</a>
              <a href="#team" className="nav-link">Team</a>
              <a href="#contact" className="nav-link">Kontakt</a>
              <button className="btn btn-primary">
                Demo Anfordern
              </button>
            </nav>
          </div>
        </div>
      </header>
      
      {/* Mobile Menu */}
      {menuOpen && (
        <div className="mobile-menu">
          <div className="container">
            <nav className="mobile-nav">
              <a href="#solutions" className="mobile-nav-link">Lösungen</a>
              <a href="#products" className="mobile-nav-link">Produkte</a>
              <a href="#technology" className="mobile-nav-link">Technologie</a>
              <a href="#team" className="mobile-nav-link">Team</a>
              <a href="#contact" className="mobile-nav-link">Kontakt</a>
              <button className="btn btn-primary mobile-btn">
                Demo Anfordern
              </button>
            </nav>
          </div>
        </div>
      )}
      
      {/* Hero Section */}
      <section className="hero-section" >
        <div className="container" >
          <div className="hero-content">
            <div className="hero-text">
              <h2 className="hero-title">Die Zukunft der vernetzten Fahrzeugtechnologie</h2>
              <p className="hero-subtitle">Innovative Softwarelösungen für moderne Fahrzeuge, die Sicherheit, Komfort und Konnektivität auf die nächste Stufe heben.</p>
              <div className="hero-buttons">
                <button className="btn btn-primary">
                  Lösungen Entdecken
                </button>
                <button className="btn btn-outline">
                  Über Uns
                </button>
              </div>
            </div>
            <div className="hero-image">
                <img src="./car_logo.png" alt="Auto Tech Innovationen car" height={400} width={400}/>
            </div>
          </div>
        </div>
      </section>
      
      {/* Features Section */}
      <section className="features-section" id="solutions">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Unsere Kernkompetenzen</h2>
            <p className="section-subtitle">
              Mit über 15 Jahren Erfahrung entwickeln wir innovative und zuverlässige Lösungen für die Automobilindustrie.
            </p>
          </div>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon-container">
                <Shield className="feature-icon" size={28} />
              </div>
              <h3 className="feature-title">Fahrerassistenzsysteme</h3>
              <p className="feature-description">
                Fortschrittliche Systeme, die Fahrzeugführer unterstützen und die Sicherheit auf der Straße erhöhen.
              </p>
              <a href="/features" className="feature-link">
                Learn more <ChevronRight className="arrow-icon" size={16} />
              </a>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon-container">
                <Cpu className="feature-icon" size={28} />
              </div>
              <h3 className="feature-title">Infotainment-Systeme</h3>
              <p className="feature-description">
                Intuitive Benutzererfahrungen für Navigation, Medien und Konnektivität im Fahrzeug.
              </p>
              <a href="/features" className="feature-link">
                Learn more <ChevronRight className="arrow-icon" size={16} />
              </a>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon-container">
                <Zap className="feature-icon" size={28} />
              </div>
              <h3 className="feature-title">E-Mobilität</h3>
              <p className="feature-description">
                Softwarelösungen für Elektrofahrzeuge, Lademanagement und Reichweitenoptimierung.
              </p>
              <a href="/features" className="feature-link">
                Learn more <ChevronRight className="arrow-icon" size={16} />
              </a>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon-container">
                <MessageCircle className="feature-icon" size={28} />
              </div>
              <h3 className="feature-title">Connected Services</h3>
              <p className="feature-description">
                Vernetzte Dienste, die Fahrzeuge mit ihrer Umgebung und digitalen Ökosystemen verbinden.
              </p>
              <a href="/features" className="feature-link">
                Learn more <ChevronRight className="arrow-icon" size={16} />
              </a>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon-container">
                <BarChart className="feature-icon" size={28} />
              </div>
              <h3 className="feature-title">Diagnostik & Analysen</h3>
              <p className="feature-description">
                Umfassende Diagnostik- und Analysewerkzeuge für Wartung und Leistungsoptimierung.
              </p>
              <a href="/features" className="feature-link">
                Learn more <ChevronRight className="arrow-icon" size={16} />
              </a>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon-container">
                <Car className="feature-icon" size={28} />
              </div>
              <h3 className="feature-title">Autonomes Fahren</h3>
              <p className="feature-description">
                Bahnbrechende Software für autonome Fahrzeuge der nächsten Generation.
              </p>
              <a href="/features" className="feature-link">
                Learn more <ChevronRight className="arrow-icon" size={16} />
              </a>
            </div>
          </div>
        </div>
      </section>
      
      {/* Products Section */}
      <section className="products-section" id="products">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Unsere Produkte</h2>
            <p className="section-subtitle">
              Entdecken Sie unsere Softwareprodukte, die Fahrzeugtechnologien revolutionieren.
            </p>
          </div>
          
          <div className="products-grid">
            <div className="product-card">
              <div className="product-image">
                <Cpu size={64} className="product-icon" />
              </div>
              <div className="product-details">
                <h3 className="product-title">AutoConnect™ Platform</h3>
                <p className="product-description">
                  Eine umfassende Plattform für die Integration vernetzter Fahrzeugdienste.
                </p>
                <ul className="product-features">
                  <li className="product-feature">
                    <ChevronRight size={20} className="feature-bullet" />
                    <span>Cloud-Konnektivität</span>
                  </li>
                  <li className="product-feature">
                    <ChevronRight size={20} className="feature-bullet" />
                    <span>Echtzeit-Datenverarbeitung</span>
                  </li>
                  <li className="product-feature">
                    <ChevronRight size={20} className="feature-bullet" />
                    <span>OTA-Updates</span>
                  </li>
                </ul>
                <button className="btn btn-primary btn-full">
                  Details Anzeigen
                </button>
              </div>
            </div>
            
            <div className="product-card">
              <div className="product-image">
                <Shield size={64} className="product-icon" />
              </div>
              <div className="product-details">
                <h3 className="product-title">SafeDrive™ Suite</h3>
                <p className="product-description">
                  Sicherheitslösungen für moderne ADAS-Systeme und Fahrerassistenz.
                </p>
                <ul className="product-features">
                  <li className="product-feature">
                    <ChevronRight size={20} className="feature-bullet" />
                    <span>Spurhalteassistent</span>
                  </li>
                  <li className="product-feature">
                    <ChevronRight size={20} className="feature-bullet" />
                    <span>Notbremsassistent</span>
                  </li>
                  <li className="product-feature">
                    <ChevronRight size={20} className="feature-bullet" />
                    <span>360° Umgebungserfassung</span>
                  </li>
                </ul>
                <button className="btn btn-primary btn-full">
                  Details Anzeigen
                </button>
              </div>
            </div>
            
            <div className="product-card">
              <div className="product-image">
                <BarChart size={64} className="product-icon" />
              </div>
              <div className="product-details">
                <h3 className="product-title">DiagnosticPro™</h3>
                <p className="product-description">
                  Professionelle Diagnosewerkzeuge für Servicewerkstätten und Hersteller.
                </p>
                <ul className="product-features">
                  <li className="product-feature">
                    <ChevronRight size={20} className="feature-bullet" />
                    <span>Umfassende Fehleranalyse</span>
                  </li>
                  <li className="product-feature">
                    <ChevronRight size={20} className="feature-bullet" />
                    <span>Prädiktive Wartung</span>
                  </li>
                  <li className="product-feature">
                    <ChevronRight size={20} className="feature-bullet" />
                    <span>Ferndiagnose</span>
                  </li>
                </ul>
                <button className="btn btn-primary btn-full">
                  Details Anzeigen
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <div className="cta-text">
              <h2 className="cta-title">Bereit für die Zukunft der Mobilität?</h2>
              <p className="cta-description">
                Kontaktieren Sie uns für eine kostenlose Beratung und erfahren Sie, wie unsere Lösungen Ihr Unternehmen voranbringen können.
              </p>
            </div>
            <div className="cta-buttons">
              <button className="btn btn-light">
                Demo Anfordern
              </button>
              <button className="btn btn-outline-light">
                Kontakt Aufnehmen
              </button>
            </div>
          </div>
        </div>
      </section>
      
      {/* Team Section */}
      <section className="team-section" id="team">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Unser Team</h2>
            <p className="section-subtitle">
              Experten aus den Bereichen Automotive Software, DevOps und Connected Technology.
            </p>
          </div>
          
          <div className="team-grid">
            <div className="team-card">
              <div className="team-image"></div>
              <div className="team-details">
                <h3 className="team-member-name">Dr. Martin Weber</h3>
                <p className="team-member-position">Geschäftsführer</p>
                <p className="team-member-bio">
                  20+ Jahre Erfahrung in der Automobilindustrie mit Fokus auf digitale Transformation.
                </p>
              </div>
            </div>
            
            <div className="team-card">
              <div className="team-image"></div>
              <div className="team-details">
                <h3 className="team-member-name">Dr. Sarah Becker</h3>
                <p className="team-member-position">CTO</p>
                <p className="team-member-bio">
                  Expertin für Embedded Systems und Fahrzeugarchitekturen mit Forschungshintergrund.
                </p>
              </div>
            </div>
            
            <div className="team-card">
              <div className="team-image"></div>
              <div className="team-details">
                <h3 className="team-member-name">Lukas Zimmermann</h3>
                <p className="team-member-position">DevOps Lead Engineer</p>
                <p className="team-member-bio">
                  DevOps-Experte mit 16 Jahren Erfahrung in der Automobilsoftwarebranche.
                </p>
              </div>
            </div>
            
            <div className="team-card">
              <div className="team-image"></div>
              <div className="team-details">
                <h3 className="team-member-name">Julia Schneider</h3>
                <p className="team-member-position">Head of Quality Assurance</p>
                <p className="team-member-bio">
                  Spezialistin für Testautomatisierung und Qualitätssicherung kritischer Systemkomponenten.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Footer */}
      <footer className="footer" id="contact">
        <div className="container">
          <div className="footer-content">
            <div className="footer-company">
              <div className="footer-logo">
                <Car size={24} className="footer-logo-icon" />
                <h3 className="footer-logo-text">AutoTech Innovationen</h3>
              </div>
              <p className="footer-address">
                Lindwurmstraße 76<br />
                80337 München<br />
                Deutschland
              </p>
              <p className="footer-contact">
                Tel: +49 89 123456789<br />
                Email: info@autotechinnovationen.com
              </p>
            </div>
            
            <div className="footer-links">
              <h4 className="footer-heading">Lösungen</h4>
              <div className="footer-nav">
                <a href="/features" className="footer-nav-link">Fahrerassistenzsysteme</a>
                <a href="/features" className="footer-nav-link">Infotainment-Systeme</a>
                <a href="/features" className="footer-nav-link">E-Mobilität</a>
                <a href="/features" className="footer-nav-link">Connected Services</a>
                <a href="/features" className="footer-nav-link">Diagnostik & Analysen</a>
              </div>
            </div>
            
            <div className="footer-links">
              <h4 className="footer-heading">Unternehmen</h4>
              <div className="footer-nav">
                <a href="/about-us" className="footer-nav-link">Über Uns</a>
                <a href="/team" className="footer-nav-link">Team</a>
                <a href="/careers" className="footer-nav-link">Karriere</a>
                <a href="/partnerships" className="footer-nav-link">Partnerschaften</a>
                <a href="/newsroom" className="footer-nav-link">Newsroom</a>
              </div>
            </div>
            
            <div className="footer-newsletter">
              <h4 className="footer-heading">Newsletter</h4>
              <p className="footer-newsletter-text">
                Abonnieren Sie unseren Newsletter für aktuelle Informationen und Innovationen.
              </p>
              <div className="newsletter-form">
                <input 
                  type="email" 
                  placeholder="Ihre E-Mail-Adresse" 
                  className="newsletter-input"
                />
                <button className="btn btn-primary newsletter-btn">
                  Abonnieren
                </button>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p className="copyright">&copy; 2025 AutoTech Innovationen GmbH. Alle Rechte vorbehalten.</p>
            <div className="legal-links">
              <div className="footer-nav">
                <a href="/terms" className="footer-nav-link">Terms & Conditions</a>
                <a href="/privacy" className="footer-nav-link">Privacy Policy</a>
                <a href="/cookies" className="footer-nav-link">Cookie Policy</a>
                <a href="/security" className="footer-nav-link">Security</a>
                <a href="/sitemap" className="footer-nav-link">Sitemap</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AutoTechWebsite;